import Swal from "sweetalert2";
 export const handleUnassignDriver = async (transferId, {fetchData, cars, rentals, coupons, contact, drivers, tours, tourBookings, employeeService, setCarsData, setRentalsData, setCouponsData, setTransfersData, setDriversData, setToursData, setTourBookingsData, setEmployeesData, setSeasonalPricing, setIsLoading, setError}) => {
    try {
      const result = await Swal.fire({
        title: "Unassign Driver",
        text: "Are you sure you want to unassign the driver from this transfer?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#1e3a8a",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, unassign",
      });

      if (result.isConfirmed) {
        await drivers.unassignDriver(transferId);
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Driver unassigned successfully",
          confirmButtonColor: "#1e3a8a",
        });
        fetchData();
      }
    } catch (error) {
      console.error("Error unassigning driver:", error);
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to unassign driver. Please try again.",
        confirmButtonColor: "#1e3a8a",
      });
    }
  };